/**
 * The below file is the Special call type service which contains method for doing the API calls.
 * @author: shivam.sharma2@velsof.com
 * @date : 10-01-2023
 */

import fetch from "auth/FetchInterceptor";
import {
  Application_Json,
  Authorization_Token,
  Get_All_Special_Call_Type,
} from "constants/ApiConstant";
import { format } from "react-string-format";
import { AUTH_TOKEN } from "redux/constants/Auth";

const SpecialCallTypeService = {};

//#region Method for Special call type dropdown

/**
 * Method for getting the Special call type dropdown
 * @param {any} param API Parameters
 * @returns Fetch Method
 */
SpecialCallTypeService.getAllSpecialCallType = function () {
  return fetch({
    url: Get_All_Special_Call_Type,
    method: "get",
    headers: {
      "Content-Type": Application_Json,
      Authorization: format(
        Authorization_Token,
        localStorage.getItem(AUTH_TOKEN)
      ),
    },
  });
};

//#endregion Method for Special call type dropdown.

export default SpecialCallTypeService;
